const dataKeysToRemove = [
  'idsCRMNovas',
  'idsCRMExistentes',
  'crmToken',
  'customer',
];

// This functions takes a page response and keeps only its instances and data
export default (response) => {
  const { instanceList, instances, settingsInstance } = response;

  Object.keys(instances).forEach((instanceId) => {
    const { data } = instances[instanceId];

    dataKeysToRemove.forEach((key) => {
      if (data && data[key]) {
        delete data[key];
      }
    });
  });

  return {
    instanceList,
    instances,
    settingsInstance,
  };
};
